import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import ImageviewerModal from "../../../components/modals/imageViewerModal/imageviewerModal";
import ImageViewerWithBadgesModal from "../../../components/modals/imageViewerWithBadgesModal/imageViewerWithBadgesModal";
import { ModalId } from "../../../enums/modalId";
import { closeModal } from "../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../redux/store/store";
import {
  UserGeneralInfoContextKeys,
  UserStore,
} from "../../../store/UserGeneralInfoStore";
import MyMedicalPaOrdersTableFromAlgolia from "./components/myMedicalPaOrdersTableFromAlgolia/myMedicalPaOrdersTableFromAlgolia";

const MyPaOrders = () => {
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL);
    }
  }, [openedModalId]);

  useEffect(() => {
    UserStore.setItem(
      UserGeneralInfoContextKeys.PARENT_TABLE,
      window.location.pathname.split("/").slice(-1)[0],
    );
  }, []);

  return (
    <div className="my-pa-orders--main-container flex h-full flex-col overflow-hidden">
      <div className="my-pa-orders__header mb-4 text-h11 font-bold text-primaryGray-1">
        My PA Orders
      </div>
      <div className="my-pa-orders__table-container flex-1 overflow-auto">
        {/* <MyPaOrdersTable
          myMedicalPaOrdersTableRef={myMedicalPaOrdersTableRef}
        /> */}
        <MyMedicalPaOrdersTableFromAlgolia />
      </div>

      <>
        {openedModalId === ModalId.IMAGE_VIEWER_MODAL && (
          <ImageviewerModal
            fileUrls={metaData?.fileUrls ?? []}
            filePaths={metaData?.filePaths ?? []}
            onClose={() => dispatch(closeModal())}
          />
        )}
        {openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL && (
          <ImageViewerWithBadgesModal
            tabs={metaData?.tabs ?? []}
            showLoading={metaData?.showLoading ?? false}
            title="Write Back Trail"
          />
        )}
      </>
    </div>
  );
};

export default MyPaOrders;
